import { createContext } from 'react'
import { PopulatedAdminData } from '../../types/populated'

export const AdminProfileContext = createContext<PopulatedAdminData>({
  adminUserRef: null,
  loading: false,
  user: null,
  userRef: null,
  userRoleRef: null,
})
